import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("lvrc_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.startsWith("/auth/")) {
      localStorage.removeItem("lvrc_token");
      window.dispatchEvent(new Event("lvrc-lock"));
    }
    return Promise.reject(e);
  }
);

const GATEWAY = /cloudflare|origin web server|<html|bad gateway|gateway time/i;

export function errMsg(e) {
  const st = e?.response?.status;
  const d = e?.response?.data?.detail;
  const raw = typeof e?.response?.data === "string" ? e.response.data : "";
  // proxy/CDN error pages (5xx without our JSON) → short, human message
  if ((st >= 500 && !d) || GATEWAY.test(String(d || raw))) return "Server or Zerodha briefly unavailable — retrying";
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const inr = (v, dp = 0) =>
  v == null ? "—" : `${v < 0 ? "-" : ""}₹${Math.abs(v).toLocaleString("en-IN", { maximumFractionDigits: dp, minimumFractionDigits: dp })}`;
export const px = (v) => (v == null ? "—" : Number(v).toFixed(2));
export const sign = (v) => (v > 0 ? "up" : v < 0 ? "down" : "text-slate-300");

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
